import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PasswordPage from '@wsc/PasswordPage';
import PropTypes from 'prop-types';
import Room from './index';
import { createSelector } from '@reduxjs/toolkit';
import useCookie from 'react-use-cookie';

const createScenePasswordSelector = (sceneId) =>
	createSelector(
		[(state) => state?.componentConfig || {}],
		(componentConfig) => {
			const scenePasswords = componentConfig?.scenePasswords || {};
			const passwordsMap = scenePasswords?.passwordMap || {};

			const pageStyling = {
				passwordButtonCopy: scenePasswords?.passwordButtonCopy,
				passwordPageStyle: scenePasswords?.passwordPageStyle,
				passwordCardStyle: scenePasswords?.passwordCardStyle,
				header: scenePasswords?.header,
				subHeader: scenePasswords?.subHeader,
				body: scenePasswords?.body,
				inputPlaceholder: scenePasswords?.inputPlaceholder,
				pwLabel: scenePasswords?.pwLabel,
				midSection: scenePasswords?.midSection,
				passwordButtonStyle: scenePasswords?.passwordButtonStyle,
				subSection: scenePasswords?.subSection,
				footer: scenePasswords?.footer,
			};

			return {
				sceneHasPassword: sceneId in passwordsMap,
				scenePassword: passwordsMap?.[sceneId],
				pageStyling,
			};
		},
	);

const RoomWithPassword = ({ sceneId, webpSupport }) => {
	const scenePasswordSelector = useMemo(
		() => createScenePasswordSelector(sceneId),
		[sceneId],
	);
	// const selectScenePasswords = createScenePasswordSelector(sceneId);
	const { sceneHasPassword, scenePassword } = useSelector(
		scenePasswordSelector,
	);

	const [scenePasswordCookie] = useCookie(
		`scene-password-${sceneId}`,
		'false',
	);

	const hasSuccessCookieForScene = scenePasswordCookie === 'true';

	const [passwordEnabled, setPasswordEnabled] = useState(
		sceneHasPassword && !hasSuccessCookieForScene,
	);

	console.log('%c RoomWithPassword rerendered ', 'color:yellow');

	return passwordEnabled ? (
		<PasswordPage
			scenePassword={scenePassword}
			sceneId={sceneId}
			setPasswordEnabled={setPasswordEnabled}
			mode={'scene'}
		/>
	) : (
		<Room sceneId={sceneId} webpSupport={webpSupport} />
	);
};

RoomWithPassword.propTypes = {
	sceneId: PropTypes.string.isRequired,
	webpSupport: PropTypes.bool,
};

RoomWithPassword.defaultProps = { webpSupport: false };

export default RoomWithPassword;
